import Table from "react-bootstrap/Table";
import PropTypes from "prop-types";
import { myId } from "../../../lib/MyLibrary";
//import axios from 'axios';

//import React from 'react'

const TableFechasTodos = ({ dataVentas }) => {
  //const {dataMX,dataCO,dataPE,dataCH}=dataVentas;
  //console.log('dataHana:...',dataHANA);
  //const ventasAOM = dataAOM?.resultVentas || '';
  //const ncAOM = dataAOM?.resultNC || '';
  //const montoVentasAOM = dataAOM?.montoVentas || Number.NaN;
  //const montoNCAOM = dataAOM?.montoNC || Number.NaN;
  //const ventasHANA = dataHANA[0]?.VENTAS || '';
  //const ncHANA = dataHANA[1]?.NC || '';
  console.log("dataVentas(todos):...", dataVentas);
  const dataTDDevolution = dataVentas.find(
    (pais) => pais.country === "TD"
  ).dataTDDevolution;
  console.log("dataTDDevolution:...", dataTDDevolution);
  //nuevo array sin el pais TD
  const dataVentasSinTD = dataVentas.filter((pais) => pais.country !== "TD");

  const totalVentasAOM = dataVentasSinTD.reduce(
    (acc, curr) => acc + parseInt(curr.dataAOM?.resultVentas, 10) || 0,
    0
  );
  const totalNCAOM = dataVentasSinTD.reduce(
    (acc, curr) => acc + parseInt(curr.dataAOM?.resultNC, 10) || 0,
    0
  );
  const totalVentasHANA = dataVentasSinTD.reduce(
    (acc, curr) => acc + parseInt(curr.dataHANA[0]?.VENTAS) || 0,
    0
  );
  const totalNCHANA = dataVentasSinTD.reduce(
    (acc, curr) => acc + parseInt(curr.dataHANA[1]?.NC) || 0,
    0
  );
  //console.log('totalVentasAOM:...',totalVentasAOM);
  //console.log('totalNCAOM:...',totalNCAOM);
  //console.log('totalVentasHANA:...',totalVentasHANA);
  //console.log('totalNCHANA:...',totalNCHANA);

  const currencyFormatter = ({ currency, value }) => {
    if (isNaN(value)) return null;
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      minimumFractionDigits: 2,
      currency,
    });
    return formatter.format(value);
  };
  const formatoMexico = (number) => {
    const exp = /(\d)(?=(\d{3})+(?!\d))/g;
    const rep = "$1,";
    let arr = number.toString().split(".");
    arr[0] = arr[0].replace(exp, rep);
    return arr[1] ? arr.join(".") : arr[0];
  };

  const formatterMiles = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const formattedNumberMiles = (number) => {
    return formatterMiles.format(number).replace("$", "");
  };

  return (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>Pais</th>
          <th>Total Ventas Aptos</th>
          <th>Total Notas Credito Aptos</th>
          <th>Monto Ventas Aptos</th>
          <th>Monto Notas Credito Aptos</th>
          <th>Total Ventas SAP</th>
          <th>Total Notas Credito SAP</th>
          <th>Devoluciones Empresariales</th>
        </tr>
      </thead>
      <tbody>
        {dataVentasSinTD.map((pais, index) => {
          return (
            <tr key={myId()}>
              <td>{pais.country || ""}</td>
              <td className="text-end">
                {formattedNumberMiles(pais.dataAOM?.resultVentas || "")}
              </td>
              <td className="text-end">
                {formattedNumberMiles(pais.dataAOM?.resultNC || "")}
              </td>
              <td className="text-end">
                {currencyFormatter({
                  currency: "USD",
                  value: pais.dataAOM?.montoVentas || Number.NaN,
                })}
              </td>
              <td className="text-end">
                {currencyFormatter({
                  currency: "USD",
                  value: pais.dataAOM?.montoNC || Number.NaN,
                })}
              </td>
              <td className="text-end">
                {formattedNumberMiles(pais.dataHANA[0]?.VENTAS || "")}
              </td>
              <td className="text-end">
                {formattedNumberMiles(pais.dataHANA[1]?.NC || "")}
              </td>
              <td>
                <div className="d-flex flex-column">
                  <div className="fs-6">
                    {formattedNumberMiles(
                      pais.dataAOMDevolution?.resultNumTrans?.recordset[0]
                        .num_trans || ""
                    )}
                  </div>
                  <div className="small">
                    {(pais.dataAOMDevolution?.resultLastTrans?.recordset[0].last_trans)
                      .replace("T", " ")
                      .replace("Z", "") || ""}
                  </div>
                </div>
              </td>
            </tr>
          );
        })}
        <tr>
          <td>TOTAL</td>
          <td className="text-end">
            {formatoMexico(parseInt(totalVentasAOM, 10))}
          </td>
          <td className="text-end">
            {formatoMexico(parseInt(totalNCAOM, 10))}
          </td>
          <td className="text-center">N/A</td>
          <td className="text-center">N/A</td>
          <td className="text-end">
            {formatoMexico(parseInt(totalVentasHANA, 10))}
          </td>
          <td className="text-end">
            {formatoMexico(parseInt(totalNCHANA, 10))}
          </td>
          <td>
            <div className="d-flex flex-column">
              <div className="fs-6 ">
                {formattedNumberMiles(dataTDDevolution?.num_trans || "")}
              </div>
              <div className="small ">
                {(dataTDDevolution?.last_trans)
                  .replace("T", " ")
                  .replace("Z", "") || ""}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

TableFechasTodos.propTypes = {
  dataVentas: PropTypes.array.isRequired,
};

export default TableFechasTodos;
